import Vue from 'vue'
import Router from 'vue-router'

import consultasPage from './../components/consultas/consultas.vue';
import validacionCorreoPage from './../components/validacion-correo/validacion-correo.vue';

let misRutas = [
	{path: '', component: consultasPage},
  {path: '/', component: consultasPage },
  {path: '/consultas', component: consultasPage },
  {path: '/validacion-correo', component: validacionCorreoPage },
  {path: '/validacion-correo/:token', props: true, component: validacionCorreoPage },
];

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: '/',
  routes: misRutas
})

